import React from "react";

import { routes } from "utilities/routing/generatedRoutes";
import ChangeClientAccessModal from "./ChangeClientAccessModal";
import { GetClientAccessType, GetClientAccessTypeLabel } from "./ClientAccessUtils";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";

interface Props {
  client: server.dto.Client
  activeSubscription: server.dto.Subscription
  optionsPanel: server.dto.OptionsPanelDataV2
  listUrl: string
}

const ClientDetailOptionsPanel = (props: Props) => {
  const [showChangeClientAccessModal, setShowChangeClientAccessModal] = React.useState(false);

  const accessType = GetClientAccessType(props.client.access);
  const changeClientAccessLabel = GetClientAccessTypeLabel(accessType);

  const instruction = {
    clientIds: [props.client.clientId],
    environments: ["internal"],
    userToClientLifeCycles: ["active"]
  } as server.dto.ListUserForAdminOneInstruction;

  const internalUsersForClientUrl = `${routes.user_ListAdminOne().absolute}?${new URLSearchParams(instruction as any).toString()}`;

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanel}
      links={[
        { text: changeClientAccessLabel, visible: true, onClick: () => { setShowChangeClientAccessModal(true); } },
        { text: "View users", visible: true, href: internalUsersForClientUrl },
        { text: "List view", visible: true, href: props.listUrl }
      ]}
    />

    <ChangeClientAccessModal
      activeSubscription={props.activeSubscription}
      client={props.client}
      isOpen={showChangeClientAccessModal}
      onClose={() => { setShowChangeClientAccessModal(false); }}
    />
  </>

};

export default ClientDetailOptionsPanel;